import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IProduktionsmallHandelssortimentPrimaryKey } from "./ProduktionsmallHandelssortimentBaseCommand";

export abstract class ProduktionsmallProduktBaseCommand extends BasicCommand<ProduktionsmallProduktBaseCommand> {
    produktionsmallGuid: string;
    handelssortimentId: number;
    produktId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ProduktionsmallProdukt";

    get primaryKey(): IPrimaryKey<IProduktionsmallProduktPrimaryKey> {
        return {
            produktionsmallGuid: this.produktionsmallGuid,
            handelssortimentId: this.handelssortimentId,
            produktId: this.produktId
        };
    }

    constructor($type: string, commandType: CommandType) {
        super($type, ProduktionsmallProduktBaseCommand.$groupKey, commandType);
    }
}

export interface IProduktionsmallProduktPrimaryKey extends IProduktionsmallHandelssortimentPrimaryKey {
    produktId: number;
}
